import { FC, HTMLAttributes } from 'react';
import { SkeletonAnimation, SkeletonVariant } from './enum';
import { SkeletonPulseStyled, SkeletonWaveStyled } from './styled';
import { SkeletonProps } from './types';

export const Skeleton: FC<HTMLAttributes<HTMLDivElement> & SkeletonProps> = ({
  width,
  height = '100%',
  animation = SkeletonAnimation.WAVE,
  variant = SkeletonVariant.RECTANGULAR,
  backgroundColor = 'grey.100',
  borderRadius,
  style,
}) => {
  return (
    <>
      {animation === SkeletonAnimation.WAVE ? (
        <SkeletonWaveStyled
          width={width}
          height={height}
          backgroundColor={backgroundColor}
          borderRadius={borderRadius}
          variant={variant}
          style={style}
        />
      ) : (
        <SkeletonPulseStyled
          width={width}
          height={height}
          backgroundColor={backgroundColor}
          borderRadius={borderRadius}
          variant={variant}
          style={style}
        />
      )}
    </>
  );
};
